// extracted by mini-css-extract-plugin
export var banner = "_hc-0";
export var closeButton = "_hc-2";
export var greenCheckmark = "_hc-3";
export var hereLink = "_hc-4";
export var titleIcon = "_hc-1";